import type { useUser } from "@clerk/react"

type User = ReturnType<typeof useUser>["user"]

export function checkAdminAccess(user: User): boolean {
	return user?.publicMetadata?.isAdmin === true
}
